<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-card class="p-0">

        <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="100" class="pr-1"><br></div>
            <div fxFlex="100" class="pr-1">
                <h3>Selecione os arquivos</h3>
                <div class="mb-1">
                    <div ng2FileDrop [ngClass]="{'dz-file-over': hasBaseDropZoneOver}" [uploader]="uploader"
                        (onFileDrop)="onFileSelected()" (change)="onFileSelected()" (fileOver)="fileOverBase($event)"
                        class="fileupload-drop-zone">
                        Solte os arquivos aqui.
                    </div>
                </div>
                <input mat-icon-button type="file" ng2FileSelect [uploader]="uploader" multiple
                    (change)="onFileSelected()" /><br />
            </div>
            <div class="col-md-9" style="margin-bottom: 40px">
                <p>Tamanho da fila: {{ uploader?.queue?.length }}</p>

                <div>

                </div>

            </div>
            <div fxFlex="100" class="pr-1">
                <ngx-datatable class="material ml-0 mr-0" [rows]="this.queue" [headerHeight]="50" [footerHeight]="120"
                    [messages]="{emptyMessage:'Nenhuma Arquivo a ser enviado'}" [scrollbarH]="true" [rowHeight]="50">
                    <ngx-datatable-column name="#" [width]="22">
                        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                            <strong>{{ rowIndex+1 }}</strong>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Nome" [flexGrow]="1" [width]="310">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span>{{row?.file?.name}}</span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Tam" [flexGrow]="1">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row?.file?.size/1024/1024 | number:'.2' }} MB
                        </ng-template>
                    </ngx-datatable-column>


                    <ngx-datatable-column name="Progresso" [flexGrow]="1">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <mat-progress-bar mode="determinate" value="{{row?.progress}}"></mat-progress-bar>
                        </ng-template>
                    </ngx-datatable-column>


                    <ngx-datatable-column name="Status" [flexGrow]="1">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span *ngIf="row?.isSuccess" class="green-icon">
                                <mat-icon>done</mat-icon>ENVIADO!
                            </span>
                            <span *ngIf="row?.isCancel" class="yellow-icon">
                                <mat-icon>block</mat-icon>CANCELADO!
                            </span>
                            <span *ngIf="row?.isError" class="red-icon">
                                <mat-icon>close</mat-icon> ERRO!
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="400">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button mat-raised-button class="green-icon" (click)="row.upload()"
                                [disabled]="row?.isReady || row?.isUploading || row.isSuccess">
                                <mat-icon>upload</mat-icon>Salvar
                            </button>

                            <button mat-raised-button class="red-icon" (click)="row.cancel()"
                                [disabled]="!row?.isUploading">
                                <mat-icon>cancel</mat-icon> Cancelar
                            </button>
                            <button mat-raised-button class="yellow-icon" (click)="row.remove();onFileSelected()">
                                <mat-icon>remove</mat-icon> Remover
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                    <div fxFlex="100" class="pr-1">
                        <br>
                        <mat-divider></mat-divider>
                    </div>
                    <ngx-datatable-footer>
                        <ng-template ngx-datatable-footer-template>
                            <ng-template #nocontent>
                                <p>Nenhum arquivo</p>
                            </ng-template>
                        
                            <div>
                            </div>
                        </ng-template>
                    </ngx-datatable-footer>
                </ngx-datatable>
            </div>
        </div>

    </mat-card>
</div>
<mat-dialog-actions>
    <div fxLayout="row wrap" fxLayout.lt-sm="column">
        <div fxFlex="100" class="pr-1"> Progresso de envio:
            <mat-progress-bar mode="determinate" value="{{uploader.progress}}">
            </mat-progress-bar>
        </div>
        <div fxFlex="100" class="mt-1">
            <button mat-raised-button class="green-icon" (click)="uploader.uploadAll()"
                [disabled]="!uploader?.getNotUploadedItems().length">
                <mat-icon>upload</mat-icon>Salvar todos
            </button>
            <button mat-raised-button class="yellow-icon" (click)="uploader.cancelAll()"
                [disabled]="!uploader?.isUploading">
                <mat-icon>cancel</mat-icon> Cancelar todos
            </button>
            <button mat-raised-button class="red-icon" (click)="uploader.clearQueue();onFileSelected()"
                [disabled]="!uploader?.queue?.length">
                <mat-icon>remove</mat-icon> Remover todos
            </button>
            
            
        </div>
    </div>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
        <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
    </button>

</mat-dialog-actions>